import { createRouter, createWebHashHistory } from "vue-router";
import authorize from "@/views/authorize";
import { getCookie } from "@/utils/getCookie";
import { getUserPage, userinfo } from "@/common/api/http.api.login";
import { localCache } from "@/utils/Cache";
import { getParams } from "@/utils/getParams";
import oauth2Config from "@/config/oauth2Config";
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/noperssion",
    name: "noperssion",
    component: () => import("@/views/noperssion.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
  },
  {
    path: "/authorize",
    name: "authorize",
    component: authorize,
  },
  {
    name: "index",
    path: "/index",
    component: () => import("@/views/index"),
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home"),
      },
      {
        // 通讯录
        name: "userInfo",
        path: "/userInfo",
        component: () => import("@/views/systemManagement/userInfo/index"),
        meta: {
          title: "通讯录",
          keepAlive: true,
          isBack: false,
        },
      },
      {
        // 通讯录 详情
        name: "userInfoDetails",
        path: "/userInfoDetails",
        component: () =>
          import("@/views/systemManagement/userInfo/userInfoDetails"),
        meta: {
          title: "通讯录",
        },
      },
      {
        // 通讯录 修改
        name: "modifyUserInfo",
        path: "/modifyUserInfo",
        component: () =>
          import("@/views/systemManagement/userInfo/modifyUserInfo"),
        meta: {
          title: "通讯录",
        },
      },
      {
        // 用户管理
        name: "userManagement",
        path: "/userManagement",
        component: () =>
          import("@/views/systemManagement/userManagement/index"),
        meta: {
          title: "用户管理",
        },
      },
      {
        // 部门管理
        name: "departmentManagement",
        path: "/departmentManagement",
        component: () =>
          import("@/views/systemManagement/departmentManagement/index"),
        meta: {
          title: "部门管理",
        },
      },
      {
        // 部门管理
        name: "postManagement",
        path: "/postManagement",
        component: () =>
          import("@/views/systemManagement/postManagement/index"),
        meta: {
          title: "职位管理",
        },
      },
      {
        // 角色管理
        name: "roleManagement",
        path: "/roleManagement",
        component: () =>
          import("@/views/systemManagement/roleManagement/index"),
        meta: {
          title: "角色管理",
        },
      },
      {
        // 菜单管理
        name: "menuManagement",
        path: "/menuManagement",
        component: () =>
          import("@/views/systemManagement/menuManagement/index"),
        meta: {
          title: "菜单管理",
        },
      },
      {
        // 通知公告
        name: "noticeManagement",
        path: "/noticeManagement",
        component: () =>
          import("@/views/systemManagement/noticeManagement/index"),
        meta: {
          title: "通知公告",
        },
      },
      {
        // 应用管理
        name: "clientManagement",
        path: "/clientManagement",
        component: () =>
          import("@/views/systemManagement/clientManagement/index"),
        meta: {
          title: "应用管理",
        },
      },
      {
        // 租户列表
        name: "tenantList",
        path: "/tenantList",
        component: () =>
          import("@/views/systemManagement/tenantManagement/tenantList/index"),
        meta: {
          title: "租户列表",
        },
      },
      {
        // 租户套餐
        name: "tenantPackage",
        path: "/tenantPackage",
        component: () =>
          import(
            "@/views/systemManagement/tenantManagement/tenantPackage/index"
          ),
        meta: {
          title: "租户套餐",
        },
      },
      {
        // 日志管理
        name: "logManagement",
        path: "/logManagement",
        component: () => import("@/views/systemManagement/logManagement/index"),
        meta: {
          title: "日志管理",
        },
      },
      {
        // 待办提醒
        name: "toDoItem",
        path: "/toDoItem",
        component: () => import("@/views/messageCenter/toDoItem/toDoItem"),
        meta: {
          title: "待办提醒",
        },
      },
      {
        // 系统通知
        name: "systemNotification",
        path: "/systemNotification",
        component: () => import("@/views/messageCenter/systemNotification/systemNotification"),
        meta: {
          title: "系统通知",
        },
      },
      {
        // 用户注册审核
        name: "userRegisterAudit",
        path: "/userRegisterAudit",
        component: () => import("@/views/systemManagement/userRegisterAudit/userRegisterAudit"),
        meta: {
          title: "用户注册审核",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (getCookie("sccp_platform")) {
    // 已登录情况
    userinfo({
      clientId: 1,
      accessToken: getCookie("sccp_platform"),
    }).then((res) => {
      if(res?.code == 200) {
        localCache.setCache("roleList", JSON.stringify(res.data?.roleList));
        localCache.setCache("userData", JSON.stringify(res.data?.userInfo));
        let roleCode = res.data?.roleList?.map((m) => m.roleCode);
        if (roleCode?.includes("super_admin")) {
          localCache.setCache("isAdmin", true);
        }
        localCache.setCache("collegeToken", res.data?.token);
        // 获取用户菜单
        getUserPage({
          clientId: 1,
        }).then((res) => {
          localCache.setCache("menuAuth", JSON.stringify(res.data));
          localCache.setCache(
              "permissionList",
              JSON.stringify(res.permissionList)
          );
          next();
        });
      }
    });
  } else {
    // 未登录,登录失效
    sessionStorage.clear();
    if (to.path != "/login") {
      next("/login");
    } else {
      next();
    }
  }
});
export default router;
